import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 32px 64px;
  max-width: 1080px;
  margin: 0 auto;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
  background: ${({ theme }) => theme.palette[10]};
  border-radius: 16px;
  padding: 24px;
  box-shadow: ${({ theme }) =>
    theme.isDark ? '0 16px 40px rgba(0,0,0,0.35)' : '0 12px 32px rgba(15,23,42,0.08)'};
`;

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionDescription = styled.span`
  color: ${({ theme }) => theme.palette[650]};
  font-size: 13px;
  line-height: 18px;
`;

export const FieldsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FieldCol = styled.div`
  flex: 1;
  min-width: 240px;
`;

export const DynamicRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px;
  border-radius: 12px;
  background: ${({ theme }) => theme.palette[200]};
  border: 1px solid ${({ theme }) => theme.palette[300]};
`;

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const AddButtonSlot = styled.div`
  display: flex;
  justify-content: flex-start;
`;
